import styled from 'styled-components';

export const HeaderDescriptionContainer = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 30.12px;
  margin: 0;
  text-align: left;
  color: ${({ theme }) => theme.contextMenu.active};
`;

export const Description = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 17.57px;
  text-align: left;
  margin: 0;
`;

export const Overline = styled.p`
  font-size: 1rem;
  font-weight: 300;
  line-height: 20.08px;
  text-align: left;
  margin: 0;
`;
